<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    width="700px"
    append-to-body
    v-dialogDrag
    class="my_rich_dialog"
    @close="close_dialog"
  >
    <div slot="title" class="dialog-header">
      <span class="title">{{ richTitle }}</span>
    </div>
    <div class="dialog-body">
      <kind_editor :item="item" :max-len="maxLen" :content.sync="editorRichText"
                   @on-content-change="onContentChange"></kind_editor>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit" size="medium"
                 :disabled="!(this.tempRichText.replace(/\s/g, '') !== this.editorRichText.replace(/\s/g, ''))">{{$t('view_public_topbar_15')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_rich_dialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    richText: {
      type: String,
      defalut: ''
    },
    richTitle: {
      type: String,
      defalut: i18n.t('components_my_rich_text_index_2425')
    },
    maxLen: {
      type: Number,
      default: 10000,
    },
    item: {
      type: Array,
      default: () => ["source",
        "selectall",
        "plainpaste",
        "undo",
        "redo",
        "fontname",
        "fontsize",
        "forecolor",
        "hilitecolor",
        "bold",
        "underline",
        "italic",
        "subscript",
        "superscript",
        "align",
        "lineheight",
        "indent",
        "outdent",
        "insertorderedlist",
        "insertunorderedlist",
        "image",
        "link",
        "unlink",
        "media",
        "table",
        "hr",
        "pagebreak",
        "clearhtml",
      ]
    }
  },
  watch: {
    resultRichText(val) {
      this.$emit('update:richText', val)  // 双向数据绑定
    },
    richText(val) {
      this.resultRichText = val
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)  // 双向数据绑定
    },
    visible(val) {
      this.dialogVisible = val
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      textLen: 0,
      tempRichText: this.richText,  // 默认内容（不变）
      editorRichText: this.richText,  // 富文本sync数据
      resultRichText: this.richText,  // 向外listArr双向绑定数据
      // resultText: this.richText.split(/<\/?\w+[^>]*>/g).filter(Boolean).join()  // 纯文本
    }
  },
  methods: {
    onContentChange(content, textLen) {
      this.textLen = textLen
    },
    close_dialog() {
      if (this.tempRichText.replace(/\s/g, '') !== this.editorRichText.replace(/\s/g, '')) {
        this.dialogVisible = true
        this.$confirm(i18n.t('view_dialog_index_170'), {
          confirmButtonText: i18n.t('view_public_topbar_24'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          type: 'warning'
        }).then(() => {
          this.dialogVisible = false
        }).catch(() => {
          this.dialogVisible = true
        })
      } else {
        this.dialogVisible = false
      }
    },
    submit() {
      if (this.textLen <= this.maxLen) {
        this.resultRichText = this.$utils.fixTagNesting(this.editorRichText)
        this.tempRichText = this.$utils.fixTagNesting(this.editorRichText)
        // let textArr = this.resultRichText.split(/<\/?\w+[^>]*>/g).filter(Boolean)
        // this.resultText = textArr.join()
        this.dialogVisible = false
      } else {
        this.$message.error(i18n.t('components_my_rich_text_my_rich_dialog_2432'))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.my_rich_dialog {
  /deep/ .el-dialog__header {
    padding: 0;
  }

  /deep/ .el-dialog__body {
    padding: 0;
    height: 100%;
  }

  /deep/ .el-dialog__footer {
    padding: 0;
  }

  .dialog-header {
    height: 50px;
    padding-left: 20px;
    border-bottom: 1px solid #e3e2e8;

    .title {
      font-size: 16px;
      line-height: 1;
      color: #333;
      line-height: 50px;
    }

    .titleTip {
      font-size: 12px;
      line-height: 1;
      color: #666;
      margin-left: 5px;
      line-height: 50px;
    }
  }

  .dialog-body {
    padding-top: 35px;
  }

  .dialog-footer {
    width: 100%;
    text-align: center;
    display: block;
    padding-top: 20px;

    /deep/ .el-button {
      margin: 28px 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_rich_text/my_rich_dialog.vue